module.exports = "/assets/data/b923e2111e55aab1dc2e58371534098e-BN45.data.json";